/* JUSTPRESS data entry (prototype 2026-10-15, THEME-PROTO-1).
   The one place modules get data that lives outside Shopify: customer photos, the saved-design ranking,
   Purchased, space balances and photo submissions. Every module asks JPData.get(kind, params) and gets the data or
   null; null means the module is not shown at all.
   - Live: reads our own service. Public data from settings.jp_data_public_base, signed-in data through
     settings.jp_data_private_base (App Proxy). Both empty today, so every module stays hidden.
   - Prototype: the demo data file (never shipped to the live theme) answers first with demo data.
   Rules that belong to the contracts, not to the screen (PAGE_BLUEPRINTS v1.1 §6.5, D07): ranking shows only
   designs saved at least 10 times. 10/15: the list is all-time (since tracking began) and is never hidden for
   age; the start date and last update are always printed under it, and the rules are public (FAQ #how-lists-work). */
(function () {
  'use strict';
  var cfg = window.jpData || {};
  var PUBLIC = {
    series_rank: '/v1/rank/collection/{id}',
    site_rank: '/v1/rank/site',
    series_ugc: '/v1/ugc/collection/{id}',
    design_ugc: '/v1/ugc/product/{id}',
    ugc_index: '/v1/ugc/index',
    ugc_feed: '/v1/ugc/feed?cursor={cursor}',
    post_comments: '/v1/posts/{key}/comments',
    profile: '/v1/profiles/{key}',
    program: '/v1/program'
  };
  var PRIVATE = {
    purchased: '/v1/me/purchased',
    balance: '/v1/me/balance',
    submissions: '/v1/me/submissions',
    reward: '/v1/me/reward',
    following: '/v1/me/following',
    my_profile: '/v1/me/profile',
    my_designs: '/v1/me/designs',
    my_posts: '/v1/me/posts'
  };
  var RANK_MIN = 10, RANK_MAX = { series_rank: 6, site_rank: 10 };
  var memo = {};

  function fill(path, params) {
    return path.replace(/\{(\w+)\}/g, function (_, k) { return encodeURIComponent(params && params[k] != null ? params[k] : ''); });
  }
  function clean(kind, data) {
    /* contract §1.6: a service that is down answers 200 with ok:false; that is "no data" like any other error */
    if (!data || typeof data !== 'object' || data.ok === false) return null;
    if (kind === 'series_rank' || kind === 'site_rank') {
      var items = (data.items || []).filter(function (x) { return x && x.product_ref && Number(x.count) >= RANK_MIN; });
      items.sort(function (a, b) { return Number(b.count) - Number(a.count); });
      var rank = 0, prev = null;
      items.forEach(function (x, i) { if (Number(x.count) !== prev) { rank = i + 1; prev = Number(x.count); } x.rank = rank; });
      items = items.slice(0, RANK_MAX[kind]);
      return items.length ? Object.assign({}, data, { items: items }) : null;
    }
    if (kind === 'series_ugc' || kind === 'design_ugc') {
      var ok = (data.items || []).filter(function (x) { return x && x.image_url && x.design && x.design.url && x.display_status === 'public'; });
      return ok.length ? Object.assign({}, data, { items: ok.slice(0, kind === 'series_ugc' ? 6 : 8) }) : null;
    }
    if (kind === 'ugc_feed') {
      /* a library post needs its design, except our own samples (official): most library samples carry no design */
      var fd = (data.items || []).filter(function (x) { return x && x.public_key && x.image_url && x.display_status === 'public' && (x.source === 'custom' || x.official === true || (x.design && x.design.url && x.design.id)); });
      /* page_url (§4b) only when it is a post page on this shop */
      fd.forEach(function (x) { if (x.design && !(x.design.url && x.design.id)) x.design = null; if (x.page_url &&!/^\/pages\/community-post\/[a-z0-9-]+$/.test(x.page_url)) x.page_url = null; });
      return fd.length ? Object.assign({}, data, { items: fd }) : null;
    }
    if (kind === 'my_posts') return (data.items || []).length ? data : null;
    if (kind === 'my_designs') return (data.items || []).length ? data : null;
    if (kind === 'profile') return data.public === true && data.key ? data : null;
    if (kind === 'post_comments') return Object.assign({}, data, { items: (data.items || []).filter(function (c) { return c && c.text && c.display_status !== 'hidden'; }) });
    if (kind === 'ugc_index') return (data.product_ids || []).length ? data : null;
    if (kind === 'balance') {
      /* balance/2 (10/16): gift spaces were dropped; only paid spaces remain */
      var keys = ['paid_available', 'paid_held', 'total_available'];
      if (data.state !== 'ready' || !keys.every(function (k) { return Number.isInteger(data[k]) && data[k] >= 0; })) return null;
      if (data.total_available !== data.paid_available) return null;
      return data;
    }
    /* "empty" is an answer too (signed in, no orders on this account): the Share your photos page says so; the module
       itself shows nothing without rows */
    if (kind === 'purchased') return data.state === 'ready' || data.state === 'partial' || data.state === 'empty' ? Object.assign({}, data, { items: data.items || [] }) : null;
    if (kind === 'reward') return data.state === 'ready' && data.double_next_order === true && !(Date.parse(data.expires_at || '') < Date.now()) ? data : null;
    if (kind === 'submissions') return (data.items || []).length ? data : null;
    if (kind === 'program') return data.state === 'running' ? data : null;
    return data;
  }
  /* a request the service never answers would leave its module waiting for good: give up after 8 s (no data) */
  /* a customer's own data is never taken from the browser's HTTP cache (an earlier answer, e.g. before an order was
     linked, would be shown again) */
  function load(url, credentials) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 8000) : 0;
    return fetch(url, { credentials: credentials, cache: credentials === 'omit' ? 'default' : 'no-store', headers: { Accept: 'application/json' }, signal: ctl ? ctl.signal : undefined })
      .then(function (r) { clearTimeout(timer); return r.ok ? r.json() : null; }, function (e) { clearTimeout(timer); throw e; });
  }
  function get(kind, params) {
    var key = kind + '|' + JSON.stringify(params || {});
    if (memo[key]) return memo[key];
    var p;
    var proto = window.JPProto && window.JPProto[kind];
    if (proto) {
      p = Promise.resolve().then(function () { return proto(params || {}); });
    } else if (PUBLIC[kind] && cfg.pub) {
      p = load(cfg.pub.replace(/\/$/, '') + fill(PUBLIC[kind], params), 'omit');
    } else if (PRIVATE[kind] && cfg.me && cfg.customer) {
      p = load(cfg.me.replace(/\/$/, '') + fill(PRIVATE[kind], params), 'same-origin');
    } else {
      p = Promise.resolve(null);
    }
    memo[key] = p.then(function (d) { return clean(kind, d); }).catch(function () { return null; });
    return memo[key];
  }
  window.JPData = { get: get };
})();
